import React from "react";
import Radium from "radium";

const _Link = require("react-router").Link;
const Link = Radium(_Link);

import InjectedTenantHtml from "../injected-tenant-html.jsx";

import { DETAILS, CREDITS } from "../../film.jsx";
import StarButton from "../star-button.jsx";

import FilmPoster from "../film-poster.jsx";
import TagList from "../tag-list.jsx";

import { makeFilmDetailString, highlightTextAtIndices } from "../../../util";

const STYLES = {
  base: {
    color: "rgb(62, 62, 62)",
    textDecoration: "none"
  },
  still: {
    width: 275,
    height: 155,
    "@media (max-width: 660px)": {
      width: "100%"
    }
  },
  poster: {
    maxWidth: "50vw",
    width: 200,
    height: 300
  },
  container: {
    display: "flex",
    alignItems: "center",
    boxShadow: "0 0 2.1rem rgba(69, 77, 93, 0.25)",
    borderRadius: 10,
    cursor: "pointer",
    transition: "0.1s all ease-in-out",
    ":hover": {
      boxShadow: "rgba(69, 77, 93, 0.36) 0px 0px 3.1rem"
    }
  },
  detail: {
    width: "100%",
    padding: "2em"
  },
  title: {
    margin: "0.25em 0"
  },
  subtitle: {
    color: "#757575",
    fontSize: 15,
    margin: "0.75em 0 0.5em"
  },
  matchedDetails: {
    margin: "-0.5em 0 0.5em"
  },
  matchedDetail: {
    margin: 0
  },
  description: {
    fontSize: "15px",
    lineHeight: "22px"
  },
  star: {
    position: "absolute",
    top: 10,
    right: 3
  }
};

const BACKGROUND_IMAGE_STYLE = {
  backgroundPosition: "center center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat"
};

class FilmListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static contextTypes = {
    isLarge: React.PropTypes.bool,
    tenant: React.PropTypes.object
  };

  render() {
    let {
        film,
        showInner,
        expanded,
        style,
        onTagChange,
        showWishlistButton,
        isWishlisted
      } = this.props,
      { isLarge } = this.context,
      stillsMode = this.context.tenant.film_guide_stills_mode,
      image = stillsMode
        ? film.still_image
        : film.poster_image || film.cover_image,
      cover = stillsMode ? film.still_image : film.cover_image;

    let poster = (
      <FilmPoster
        backgroundSrc={image}
        style={stillsMode ? STYLES.still : STYLES.poster}
        showInnerOnHover={!showInner && !!image}
        forceHover={
          expanded && Radium.getState(this.state, "container", ":hover")
        }
      >
        {!expanded && (
          <h1 style={{ padding: "1em", lineHeight: 1 }}>{film.name}</h1>
        )}
        {showWishlistButton && (
          <div style={STYLES.star}>
            <StarButton wishlisted={isWishlisted} type="films" id={film.id} />
          </div>
        )}
      </FilmPoster>
    );

    // Highlight matchec content if necessary
    if (film._search_match_details) {
      film = Object.assign({}, film); // so we can update html inline
      // film._search_match_details.forEach(({ key, indices }) => {
      //   film[`html_${key}`] = highlightTextAtIndices(film[key], indices)
      // });
      film._matched_details = [];
      film._search_match_details.forEach(({ key, indices }) => {
        let chunks = key.split(".");
        if (chunks.length === 2) {
          let [type, field] = chunks;
          film._matched_details.push({
            key: (type === "details" ? DETAILS : CREDITS)[field],
            value: film[type][field]
          });
        }
      });
    }

    return (
      <Link
        to={{ pathname: `/films/${film.id}`, state: { fromGuide: true } }}
        style={[STYLES.base, style]}
      >
        {expanded ? (
          <div
            ref="container"
            style={[
              STYLES.container,
              cover &&
                Object.assign({}, BACKGROUND_IMAGE_STYLE, {
                  backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.85)), url("${cover}")`
                })
            ]}
          >
            {isLarge && !stillsMode && poster}
            <div style={STYLES.detail}>
              <h1 style={STYLES.title}>
                {film.html_name ? (
                  <span dangerouslySetInnerHTML={{ __html: film.html_name }} />
                ) : (
                  film.name
                )}
              </h1>
              <h2 style={STYLES.subtitle}>
                {makeFilmDetailString(film.details)}
              </h2>
              {film._matched_details && film._matched_details.length ? (
                <div style={STYLES.matchedDetails}>
                  {film._matched_details.map(d => {
                    return (
                      <h2
                        style={[STYLES.subtitle, STYLES.matchedDetail]}
                        key={d.key}
                      >
                        <span style={{}}>{d.key}</span>: {d.value}
                      </h2>
                    );
                  })}
                </div>
              ) : null}
              <div style={STYLES.description}>
                {film.html_short_description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: film.html_short_description
                    }}
                  />
                ) : (
                  <div>{film.short_description}</div>
                )}
              </div>
              <TagList
                style={{ marginTop: "0.5em" }}
                tags={film.tags}
                tooltip={t => `Filter films by "${t}"`}
                onClick={tag =>
                  onTagChange(tag.id, true, { ignoreScrollBehavior: false })
                }
              />
            </div>
          </div>
        ) : (
          poster
        )}
      </Link>
    );
  }
}

export default Radium(FilmListItem);



// WEBPACK FOOTER //
// ./src/app/components/partials/film-list/film-list-item.jsx